import onlyNumbers from '../../commons/utils/only-numbers';
import { isTelevendas } from '../../commons/utils/sales-channel';

const translatePhone = maskedPhone => {
  const phone = onlyNumbers(maskedPhone);
  if (phone) {
    return {
      ddd: phone.slice(0, 2),
      number: phone.slice(2, phone.length)
    };
  }
  return {};
};

const getPhones = (mainPhone, secondaryPhone, receiveWhatsApp) => {
  const main = translatePhone(mainPhone);

  if (secondaryPhone && receiveWhatsApp === 'true') {
    const cellphone = translatePhone(secondaryPhone);
    return { main, cellphone };
  }

  return { main };
};

const translateToEmptyIfValueNil = value => (value ? value : '');

const translatePassword = value => (!isTelevendas() ? translateToEmptyIfValueNil(value) : null);

export const translateToCustomer = (customerType, customer) => {
  const {
    email,
    password,
    phone,
    cellphone,
    offersEmail,
    receiveWhatsApp,
    cpf,
    name,
    birthday,
    gender,
    zipCode,
    address,
    number,
    additionalInfo,
    reference,
    neighborhood,
    city,
    state
  } = customer;

  if (customerType === 'guest') {
    return {
      email: email,
      telephones: getPhones(phone, cellphone, receiveWhatsApp),
      optIn: {
        mailing: offersEmail,
        mailingSoub: offersEmail,
        receiveWhatsApp,
        privacyPolicyV1: true
      },
      address: {
        zipCode: onlyNumbers(zipCode),
        address,
        number,
        recipientName: translateToEmptyIfValueNil(name),
        additionalInfo,
        reference,
        neighborhood,
        city,
        state,
        name: 'Principal',
        addressType: 'PERSONAL'
      },
      type: {
        pf: {
          fullName: translateToEmptyIfValueNil(name),
          cpf: onlyNumbers(cpf),
          birthday: translateToEmptyIfValueNil(birthday),
          guest: true
        }
      }
    };
  } else {
    return {
      telephones: getPhones(phone, cellphone, receiveWhatsApp),
      account: {
        id: translateToEmptyIfValueNil(email),
        password: translatePassword(password)
      },
      optIn: {
        mailing: offersEmail,
        mailingSoub: offersEmail,
        receiveWhatsApp,
        privacyPolicyV1: true
      },
      type: {
        pf: {
          fullName: translateToEmptyIfValueNil(name),
          cpf: onlyNumbers(cpf),
          gender: translateToEmptyIfValueNil(gender),
          birthday: translateToEmptyIfValueNil(birthday),
          guest: false
        }
      }
    };
  }
};

export const translateToCustomerPj = customer => {
  const {
    buyer: { buyerPassword, buyerEmail, buyerName, buyerPhone, offersEmail },
    company: {
      cnpj,
      corporateName,
      fantasyName,
      contactName,
      phone,
      phoneExtensionRegistry,
      nationalSimple,
      stateRegistry,
      taxInfo,
      billing: {
        address,
        neighborhood,
        city,
        state,
        reference,
        number,
        billingEmail,
        additionalInfo,
        zipCode
      }
    }
  } = customer;

  return {
    email: billingEmail,
    telephones: {
      main: { ...translatePhone(phone), extension: phoneExtensionRegistry },
      cellphone: translatePhone(buyerPhone)
    },
    optIn: {
      mailing: offersEmail,
      receiveSMS: false,
      mailingSoub: offersEmail
    },
    account: {
      id: buyerEmail,
      password: translatePassword(buyerPassword),
      telephones: {
        main: {
          ...translatePhone(phone),
          extension: phoneExtensionRegistry
        },
        cellphone: translatePhone(buyerPhone)
      },
      name: buyerName
    },
    address: {
      name: 'COMERCIAL',
      recipientName: contactName,
      address,
      number,
      additionalInfo,
      reference,
      neighborhood,
      city,
      state,
      zipCode: onlyNumbers(zipCode)
    },
    type: {
      pj: {
        cnpj: onlyNumbers(cnpj),
        indicatorIe: {
          nationalSimple: taxInfo === 'TAX_PAYER' && nationalSimple === 'true',
          stateInscription: taxInfo === 'EXEMPT_TAXPAYER' ? '' : stateRegistry,
          indicatorIERecipient: taxInfo
        },
        corporateName,
        fantasyName,
        responsibleName: contactName
      }
    }
  };
};
